/**
 * 已开发票
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './InvoiceModal.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Form, Input } from 'antd';

const layout = {
    labelCol: {
        span: 4
    }
};

const InfoModal = (props) => {

    const [form] = Form.useForm();
    const [info, setInfo] = useState({});
    const [confirmLoading, setConfirmLoading] = useState(false);

    const _handleOk = () => {
        form.validateFields().then(({ invoiceMemo, invoiceNo }) => {
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.pay.RechargeRecordMisService.openTicket', {
                payId: props.data.payId,
                invoiceMemo: !!invoiceMemo ? invoiceMemo : undefined,
                invoiceNo
            }, 'POST').then(() => {
                message.success('操作成功');
                setConfirmLoading(false);
                props.closeMode && props.closeMode(true);
            }).catch((e = {}) => {
                message.success(e.message || '提交异常');
                setConfirmLoading(false)
                props.closeMode && props.closeMode();
            });
        });
    }

    const _handleCancel = () => {
        props.closeMode && props.closeMode();
    }

    useEffect(() => {
        if (props.data.userId) {
            http('/?cmd=com.xqxc.api.pig.mis.pay.RechargeRecordMisService.getEnterpriseInfo', { userId: props.data.userId }).then(res => {
                if (res.errCode === 0) {
                    setInfo(res.result || {});
                }
            }).catch((res = {}) => message.error(res.message))
        } else {
            message.error('企业用户ID不存在');
        }
    }, []);

    return (
        <Modal
            width={520}
            centered
            title={props.title}
            visible={props.visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >
            <Form {...layout} className={styles.container} form={form} labelAlign='right'>
                <Form.Item label="企业名称">{info.epName}</Form.Item>
                <Form.Item label="注 册 号">{info.epLicenseNo}</Form.Item>
                <Form.Item label="法人名称">{info.epLegalName}</Form.Item>
                <Form.Item label="邮箱地址">{info.email}</Form.Item>
                <Form.Item label="开票单号" name="invoiceNo" rules={[{ required: true, message: '请输入' }]}>
                    <Input placeholder='请输入' />
                </Form.Item>
                <Form.Item label="备注" name="invoiceMemo" rules={[{ min: 2, message: '至少两个字符' }]} >
                    <Input.TextArea placeholder='请输入' minLength={2} />
                </Form.Item>
            </Form>
        </Modal>
    );

}

InfoModal.propTypes = {
    data: PropTypes.any, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

export default InfoModal;